// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingVideoClickPlayEvent
 */
export var MarketingVideoClickPlay = function (_a) {
    var pageName = _a.pageName, sectionName = _a.sectionName, videoName = _a.videoName;
    return ({
        name: "MarketingVideo Click Play",
        parameters: {
            cdf_entity: "MarketingVideo",
            cdf_action: "Click",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_name: sectionName !== undefined && sectionName !== null ? sectionName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            video_name: videoName !== undefined && videoName !== null ? videoName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
